import styled from 'styled-components';

export const Container = styled.div`
  .header-toolbar {
    height: 56px;
    margin-left: 56px;
    width: calc(100% - 56px);
    padding: 0.5em 1em;
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.07);

    .nav-link,
    .open-menu {
      color: ${(props) => props.theme.$dark};
    }

    @media only screen and (max-width: 768px) {
      margin-left: 0;
      width: 100%;
    }
  }

  .sidebar-menu {
    width: 59px;
    height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1040;
    color: ${(props) => props.theme.$white};
    transition: width 0.3s;
    white-space: nowrap;
    display: block;
    background-color: ${(props) => props.theme.$dark};
    
    &.representant{
      background-color: ${(props) => props.theme.$japanese_indigo}
    }

    @media only screen and (max-width: 768px) {
      left: -59px;
    }

    .nav-chatbot {
      position: absolute;
      left: 8px;
      bottom: 8px;
    }

    .box-logo {
      width: 100%;
      padding: 7.2px;
      height: 59px;
      display: inline-block;
      background: ${(props) => props.theme.$ebony_clay};
      
      &.representant{
        background: ${(props) => props.theme.$yankees_blue};
      }

      .close-menu {
        display: none;
        color: ${(props) => props.theme.$white};
      }

      .icon-logo {
        display: inline-block;
        overflow: hidden !important;

        img {
          max-height: 30px;
        }
      }
    }

    .nav-link {
      color: ${(props) => props.theme.$white};
      border-left: 5px solid transparent;
      display: flex;
      align-items: center;
      width: 59px;
      padding: 0;

      i {
        font-size: 18px;
      }

      &:hover {
        background: ${(props) => props.theme.$dark_light};
      }

      &.representant{
        &:hover {
         background: ${(props) => props.theme.$metallic_blue};
       }
      }

      .nav-icon {
        height: 36px;
        width: 45px;
        margin: 5px 8px 5px 3px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          height: 25px;
          max-width: 40px;
        }
      }

      .nav-name,
      .nav-arrow {
        opacity: 0;
        display: none;
        transition: opacity 0.5s;
      }

      .nav-arrow {
        transform: rotate(180deg);
        transition: transform 0.5s;
      }

      .oi-chevron-bottom {
        font-size: 0.6rem;
      }

      &.collapsed {
        .nav-arrow {
          transform: rotate(0deg);
        }
      }
    }

    .second-menu {
      background: ${(props) => props.theme.$dark_medium};
      .nav-link {
        padding: 7px 0 7px 25px;
      }
    }

    &.representant {
      .second-menu {
        background: ${(props) => props.theme.$police_blue};
      }
    }

    .nav-current {
      .nav-link {
        border-color: ${(props) => props.theme.$primary_green_light};

        &.representant {
          border-color: transparent;
        }
      }

      .representant{
        .nav-icon {
          background: ${(props) => props.theme.$white};
          border-radius: 4px;

          img {
            filter: brightness(0) saturate(100%) invert(21%) sepia(25%) saturate(976%) hue-rotate(157deg) brightness(91%) contrast(93%);
          }
        }
      }
    }

    .monitoring-notify {
      transform: translate(-50%, -50%) !important;
      left: 42px !important;
      top: 13px !important;
    }
    
    .scroll-menu {
      height: calc(100vh - 59px - 69px);
      scrollbar-color: ${(props) => props.theme.$dark_light} ${(props) => props.theme.$dark};

      @media only screen and (max-width: 1280px) {
        overflow-y: scroll;
        overflow-x: hidden;
      }

      &::-webkit-scrollbar {
        width: 12px;
      }

      &::-webkit-scrollbar-track {
        background: ${(props) => props.theme.$dark};
      }

      &::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.$dark_light};
        border-radius: 10px;
        border: 3px solid ${(props) => props.theme.$dark};
      }

      &::-webkit-scrollbar-thumb:hover {
        background: ${(props) => props.theme.$ebony_clay};
      }
    }

    &.representant {
        .scroll-menu {
          scrollbar-color: ${(props) => props.theme.$police_blue} ${(props) =>
  props.theme.$japanese_indigo};

          &::-webkit-scrollbar-track {
            background: ${(props) => props.theme.$japanese_indigo};
          }

          &::-webkit-scrollbar-thumb {
            background: ${(props) => props.theme.$police_blue};
            border: 3px solid ${(props) => props.theme.$japanese_indigo};
          }

          &::-webkit-scrollbar-thumb:hover {
            background: ${(props) => props.theme.$yankees_blue};
          }
        }
      }

    &.open-menu {
      width: 300px;
      box-shadow: 0.25rem 0 0.75rem rgba(0, 0, 0, 0.3);

      .scroll-menu {
        overflow-y: scroll;
        scrollbar-width: thin;
        height: calc(100vh - 59px - 69px);
      }

      @media only screen and (max-width: 768px) {
        left: 0;
      }

      .box-logo {
        .icon-logo {
          overflow: auto;
        }

        .close-menu {
          display: flex;
          &:hover {
            text-decoration: none;
          }
        }
      }

      .nav-link {
        width: 100%;

        &:after,
        &:before {
          display: none;
        }

        .nav-name,
        .nav-arrow {
          opacity: 1;
          display: inline;
        }
      }
    }


  &.hasTopBanner {
    top: 80px;

    @media only screen and (max-width: 768px) {
      top: 240px;
    }
  }

`;
